import { ChangeEvent, useState } from 'react';

import classNames from 'classnames';

import Checkbox from 'components/common/ui-kit/Checkbox';
import useAppDispatch from 'hooks/common/useAppDispatch';
import terms from 'i18n';
import { Contract, ContractState } from 'models/applications/contracts';
import { createToast } from 'redux/actions';
import { contractApi } from 'redux/api/applications/contract-api';
import './contract-informing.scss';

type ContractInformingProps = {
  className?: string;
  contract: Contract;
};

export default function ContractInforming({
  className,
  contract,
}: ContractInformingProps) {
  const initialChecked = contract.informing;
  const dispatch = useAppDispatch();
  const today = new Date().getTime();
  const [isChecked, setIsChecked] = useState(initialChecked);
  const [isPrevChecked, setIsPrevChecked] = useState(initialChecked);
  const [update] = contractApi.useLazySetInformingQuery();

  if (isPrevChecked !== initialChecked) {
    setIsChecked(initialChecked);
    setIsPrevChecked(initialChecked);
  }

  if (
    contract.state !== ContractState.APPROVED ||
    today <= new Date('2025-08-08T00:00:00+03:00').getTime() ||
    today >= new Date('2025-09-25T12:00:00+03:00').getTime()
  ) {
    return null;
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    setIsChecked(newValue);
    update({
      contractId: contract.id,
      informing: newValue,
    })
      .unwrap()
      .catch(() => {
        setIsChecked(!newValue);
        dispatch(
          createToast(
            'Во время подтверждения информирования о необходимости зачисления произошла ошибка. Пожалуйста, попробуйте позже.',
            'danger'
          )
        );
      });
  };

  return (
    <div className={classNames('card', className)}>
      <span className="card__header contract-informing__header">
        {terms.CONTRACT_INFORMING}
      </span>
      <Checkbox
        checked={isChecked}
        onChange={handleChange}
        text={terms.CONTRACT_INFORMING_APPROVEMENT}
      />
      <p className="contract-informing__description">
        {terms.CONTRACT_INFORMING_DESCRIPTION}{' '}
        <b>{terms.CONTRACT_INFORMING_START_DATE}</b>
      </p>
    </div>
  );
}
